export default {
  "activityBonusConfig.title": "Activity Bonus Config",
  "activityBonusConfig.column.no": "#NO",
  "activityBonusConfig.column.eventId": "Event ID",
  "activityBonusConfig.column.bonusAmount": "Bonus Amount",
  "activityBonusConfig.column.wager": "Wager",
  "activityBonusConfig.column.enable": "Enable",
  "activityBonusConfig.column.createTime": "Create Time",
  "activityBonusConfig.column.action": "Action",
  "activityBonusConfig.action.edit": "Edit",
  "activityBonusConfig.action.enable": "Enable",
  "activityBonusConfig.action.disable": "Disable",
  "activityBonusConfig.form.eventType": "Event Type",
  "activityBonusConfig.form.bonusAmount": "Bonus Amount",
  "activityBonusConfig.form.wager": "Wager",
  "activityBonusConfig.search.enable": "Enable",
  "activityBonusConfig.search.disable": "Disable",
  "activityBonusConfig.confirm.enable.title": "Enable Activity Bonus: {eventId}",
  "activityBonusConfig.confirm.disable.title": "Disable Activity Bonus: {eventId}",
  "activityBonusConfig.confirm.enable.content": "Are you sure you want to enable this activity bonus?",
  "activityBonusConfig.confirm.disable.content": "Are you sure you want to disable this activity bonus?",
  "activityBonusConfig.confirm.ok": "Confirm",
  "activityBonusConfig.confirm.cancel": "Cancel",
  "activityBonusConfig.add": "Add",
  "activityBonusConfig.edit": "Edit",
};